export const getImageUrl = (path) => {
  if (!path) return null;

  // Already absolute URL
  if (path.startsWith('http')) {
    return path;
  }

  // If backend already sent full uploads path
  if (path.startsWith('/uploads')) {
    return `${process.env.REACT_APP_BACKEND_URL}${path}`;
  }

  // Filename only → assume members upload folder
  return `${process.env.REACT_APP_BACKEND_URL}/uploads/members/${path}`;
};
